'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var GridToolbarSystemStatusFaresReoptController = function GridToolbarSystemStatusFaresReoptController($scope, toolbarGridService, configurationService, failureAuditLogService) {
  $scope.isReoptimizeButtonShown = false;
  $scope.isDeleteButtonShown = false;
  $scope.isDuplicateButtonShown = false;
  $scope.selectedRows = [];
  $scope.onRowSelection = function (selectedRows) {
    toolbarGridService.rowSelectionHandler($scope, selectedRows);
  };
  $scope.reOptimizeFares = function () {
    if (validateReoptimization($scope.selectedRows) && validateUserIsApprovedForPos($scope.selectedRows)) {
      $scope.$emit('system-status-fares-reoptimization:reoptimize', $scope.selectedRows);
    }
  };
  $scope.addFaresReopt = function (pos, market, cabin) {
    toolbarGridService.addRowForFaresReopt($scope, pos, market, cabin);
  };
  $scope.duplicateFaresReopt = function () {
    var propertiesToDuplicate = ['processingCarrier', 'pos', 'market', 'foCabin'];
    toolbarGridService.duplicateRow($scope, propertiesToDuplicate);
  };
  $scope.remove = function () {
    toolbarGridService.removeRow($scope);
  };
  $scope.$on('configuration-status-demand-reinitialization', function () {
    $scope.clearModifiedCells();
  });
  $scope.pushFailureAuditLogEvent = function () {
    var configuredCarriers = configurationService.getConfiguredHostCarriers().split(',');
    failureAuditLogService.sendRequest(configuredCarriers);
  };
  function validateReoptimization(selectedRows) {
    var invalidRows = _.filter(selectedRows, validateRow);
    if (invalidRows.length > 0) {
      displayErrors(getErrMessages(invalidRows[0]));
      return false;
    } else {
      return true;
    }
  }
  function displayAccessErrorMessages(invalidRows) {
    var unauthorisedPOSes = '';
    invalidRows.forEach(function (row) {
      if (unauthorisedPOSes.indexOf(row.pos) === -1) {
        if (unauthorisedPOSes.length > 0) {
          unauthorisedPOSes = unauthorisedPOSes.concat(', ');
        }
        unauthorisedPOSes = unauthorisedPOSes.concat(row.pos);
      }
    });
    toastr.error('User does not have access to the following POS : ' + unauthorisedPOSes);
  }
  function validateRow(row) {
    return !row.market || !row.foCabin || !row.pos;
  }
  function getErrMessages(row) {
    var errorMsg = [];
    if (!row.pos) {
      errorMsg.push('Pos has to be filled');
    }
    if (!row.market) {
      errorMsg.push('Market has to be filled');
    }
    if (!row.foCabin) {
      errorMsg.push('Cabin has to be filled');
    }
    return errorMsg;
  }
  function displayErrors(messages) {
    for (var i = 0; i < messages.length; i++) {
      toastr.error(messages[i]);
    }
  }
  function validateUserIsApprovedForPos(selectedRows) {
    var invalidRows = _.filter(selectedRows, getNonAuthorisesPoses);
    $scope.selectedRows = _.filter(selectedRows, getAuthorisedPoses);
    if (invalidRows.length > 0) {
      displayAccessErrorMessages(invalidRows);
    }
    return $scope.selectedRows.length !== 0;
  }
  function isUserAuthorizedForCurrentPos(levels, pos) {
    return _.indexOf(levels, pos) !== -1;
  }
  function getNonAuthorisesPoses(item) {
    return !isUserAuthorizedForCurrentPos(configurationService.getUserPrimaryPOSLevel(), item.pos) && !isUserAuthorizedForCurrentPos(configurationService.getUserLastPOSLevel(), item.pos);
  }
  function getAuthorisedPoses(item) {
    return isUserAuthorizedForCurrentPos(configurationService.getUserPrimaryPOSLevel(), item.pos) || isUserAuthorizedForCurrentPos(configurationService.getUserLastPOSLevel(), item.pos);
  }
};
GridToolbarSystemStatusFaresReoptController.$inject = ['$scope', 'ToolbarGridService', 'ConfigurationService', 'FailureAuditLogService'];
module.exports = GridToolbarSystemStatusFaresReoptController;